import { Component } from '@angular/core';

@Component({
	selector: 'seira-zoneamentos',
	templateUrl: './zoneamentos.component.html',
	styleUrls: ['./zoneamentos.component.scss'],
})
export class ZoneamentosComponent {}
